import { StyledEngineProvider } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Provider } from 'react-redux';

import './index.css';
import { store } from './store';
import ThemeManager from './app/ThemeManager';

import { requiredLogToResources, requiredLogToScopes } from './utils/user';
import { type LogtoConfig, LogtoProvider } from '@logto/react';

const ErrorFallback = ({ error }: FallbackProps) => {
	const message = error instanceof Error ? error.message : String(error);
	return <p style={{ color: 'red' }}>An error occurred: {message}</p>;
};

const config: LogtoConfig = {
	appId: import.meta.env.VITE_LOGTO_APP_ID,
	endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
	resources: requiredLogToResources,
	scopes: requiredLogToScopes,
};

const container = document.getElementById('root');
if (container) {
	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<StyledEngineProvider injectFirst>
					<Provider store={store}>
						<LogtoProvider config={config}>
							<ThemeManager />
						</LogtoProvider>
					</Provider>
				</StyledEngineProvider>
			</ErrorBoundary>
		</React.StrictMode>
	);
}
